import { render, staticRenderFns } from "./TableSpecimensMatch.vue?vue&type=template&id=456255ca&scoped=true"
import script from "./TableSpecimensMatch.vue?vue&type=script&lang=js"
export * from "./TableSpecimensMatch.vue?vue&type=script&lang=js"
import style0 from "./TableSpecimensMatch.vue?vue&type=style&index=0&id=456255ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456255ca",
  null
  
)

export default component.exports